<template>
  <div class="box border-box" :style="{'border': (border ? '':'none')}">
    <div ref="locationList" class="scroll-wrap" ui-jp="mCustomScrollbar" data-mcs-theme="minimal-dark" ui-options="{theme:'minimal-dark', height: '200px'}" :style="[{'max-height': height + 'px'}, {'height': height + 'px'}, {'overflow-y': 'scroll'}]">
      <div class="box-body">
        <div v-for="(item, index) in value" :key="index">
          <label class="md-check"  v-if="showConfirmed(item)">
            <input type="checkbox" v-model="item[valueKey]" @change="changeHandler(item)" :disabled="disabled(item)"/>
            <i class="blue"></i>
            <span v-if="!isDetail">
              {{item.visitorAssetCode.assetStr}} ({{item.assetSerial}})
              <p style="color:#999">{{item.assetMemo}}</p>
            </span>
            <span v-if="isDetail">
              {{item.visitorAssetCode.assetStr}}({{item.assetSerial}}) - {{item.assetManufacturer}} {{item.assetModel}}
              <p style="color:#999">{{item.assetMemo}}</p>
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      checkboxDisable: {
        type: Boolean,
        default: false
      },
      height: { type: Number, default: function(){ return 170}},
      value: {
        type: Array,
        default: () => []
      },
      border: {
        type: Boolean,
        default: function() {
          return true;
        }
      },
      editMode: {
        type: Boolean,
        default: function() {
          return false;
        }
      },
      valueKey: {
        type: String,
        default: () => {
          return 'checked'
        }
      },
      isDetail: {
        type : Boolean,
        default: function(){
          return false;
        }
      }
    },
    data(){
      return {
        formEdit: false
      }
    },
    mounted(){
      this.formEdit = this.editMode;
      $(".scroll-wrap").mCustomScrollbar({
        axis:"y" // horizontal scrollbar
      });
    },
    computed: {
      disabled(){
        return(item) =>{
          if(!this.formEdit)
            return true;
        }
      },
      showConfirmed(){
        return (item)=>{
          if(this.valueKey != 'checked' && !item.checked){
            return false;
          }
          return true;
        }

      },
      icon() {
        return(item) =>{
          if(item.isLock){
            return 'icon-security'
          }

          if(item.reserved){
            return 'icon-complete'
          }
          if(!item.reserved){
            return 'icon-fail'
          }
          return 'icon-complate';

        }
      },
    },
    methods :{
      changeHandler(item){
        if(this.valueKey == 'checked'){
          item['confirmed'] = false;
        }else{

        }
        this.$emit(
          "input",
          this.value
        );
        this.$emit(
          "change",
          this.value
        );
        this.$forceUpdate();
      },
      updateInput: function(event) {
        var updatedText = event.target.value;
        this.value = updatedText;
        this.$emit('input', event.target.value);
      },
      confirmInput(event) {
        //this.$parent.$emit("confirmInput");
        this.$emit("confirmInput");
        this.formEdit = false;
      },
      cancelInput(event) {
        //this.$parent.$emit("cancelInput");
        this.$emit('input', this.tempData);
        this.formEdit = false;
      },
    }
  }
</script>

<style>

</style>
